// extracted by mini-css-extract-plugin
export var accordion = "_ep-0";
export var chevron = "_ep-3";
export var closed = "_ep-2";
export var content = "_ep-4";
export var open = "_ep-1";
export var rotate = "_ep-5";